(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Initiate",
            {
                url: "/Initiate",
                component: "initiate",
                resolve: {
                    agent: ["agentApi", function (agentApi) {
                        return agentApi.getCurrentAgent();
                    }]
                }
            });
    }]);

    app.component("initiate",
        {
            templateUrl: "/App/Transaction/Initiate/template.html",
            controller: initiateController,
            bindings: {
                agent: "<",
                transactionGroup: "<"
            }
        });

    initiateController.$inject = [
        "$state", "$scope", "clientApi", "transactionApi", "$q", "$mdDialog", "agentApi", "_",
        "transactionRelationshipApi", "questionApi", "transactionQuestionApi", "transactionProductApi",
        "transactionGroupProductApi", "prosperaSalesForceApi", "moment", "personApi", "salesForceApi"
    ];

    function initiateController($state, $scope, clientApi, transactionApi, $q, $mdDialog, agentApi, _, transactionRelationshipApi, questionApi, transactionQuestionApi, transactionProductApi, transactionGroupProductApi, prosperaSalesForceApi, moment, personApi, salesForceApi) {
        $scope.$parent.$ctrl.getCurrentStage($state);
        var $ctrl = this;

        var errorAlert = $mdDialog.alert({
            title: "An error saving has occurred.  Please try again.",
            ariaLabel: "Error alert",
            ok: "Ok",
            skipHide: true
        });

        ng.extend($ctrl,
            {
                ui: { saving: false, pageIndex: 0, existing: false },
                client: { Person: {} },
                clientTemp: {},
                transaction: {},
                addAgent: addAgent,
                removeSecondaryAgent: removeSecondaryAgent,
                resetSecondaryAgents: resetSecondaryAgents,
                searchClients: searchClients,
                searchAgents: searchAgents,
                save: save,
                setQuestions: setQuestions,
                setProducts: setProducts,
                getProsperaAdvisorClients: getProsperaAdvisorClients,
                selectProsperaClient: selectProsperaClient,
                searchProsperaClients: searchProsperaClients
            });

        this.$onInit = function () {
            $ctrl.primaryAgent = $ctrl.agent;
            if ($ctrl.primaryAgent)
                $ctrl.primaryAgent.Term = $ctrl.primaryAgent.Person.FirstName + " " + $ctrl.primaryAgent.Person.LastName;
            $ctrl.secondaryAgents = [];

            if ($ctrl.transactionGroup && $ctrl.transactionGroup.Name === "Prospera") {
                getProsperaAdvisorClients();
            }
        }

        function searchAgents(term) {
            return agentApi.searchAgentsForTransactionGroup($ctrl.transactionGroup.Id, term)
                .then(function (result) {
                    var results = [];
                    ng.forEach(result,
                        function (row) {
                            row.Term = row.Person.FirstName + " " + row.Person.LastName;
                            if (!$ctrl.primaryAgent || (($ctrl.primaryAgent && $ctrl.primaryAgent.Id !== row.Id) && !_.find($ctrl.secondaryAgents, function (ag) { return ag.Id === row.Id; })))
                                results.push(row);
                        });
                    return results;
                });
        }

        function addAgent(agent) {
            if (agent)
                $ctrl.secondaryAgents.push(agent);
        };

        function resetSecondaryAgents() {
            if (!$ctrl.primaryAgent)
                $ctrl.secondaryAgents = [];
        }

        function removeSecondaryAgent(agent, $event) {
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to remove this agent?",
                targetEvent: $event,
                ariaLabel: "Confirm initiate transaction",
                ok: "Yes",
                cancel: "No",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm)
                .then(function () {
                    _.remove($ctrl.secondaryAgents, { Id: agent.Id });
                },
                    function () { });
        }

        function searchClients(term) {
            return clientApi.searchAgentClients($ctrl.primaryAgent.Id, term)
                .then(function (result) {
                    console.log(result)
                    ng.forEach(result, function (row) { row.Term = row.Client.Person.FirstName + " " + row.Client.Person.LastName + (row.Client.Person.LastFourSsn ? " (" + row.Client.Person.LastFourSsn + ")" : ""); });
                    return result;
                });
        }

        function searchProsperaClients(valueStartsWith) {

            return _.filter($ctrl.prosperaClients, function (d) {

                return d["Name"].toLowerCase().startsWith(valueStartsWith);
            });
        }

        function selectProsperaClient(selectedClient) {

            if (selectedClient != null) {
                $ctrl.ui.saving = true;

                $ctrl.client.Person.FirstName = selectedClient.FirstName;
                $ctrl.client.Person.MiddleName = selectedClient.MiddleName;
                $ctrl.client.Person.LastName = selectedClient.LastName;

                //get prospera client info from Salesforce
                prosperaSalesForceApi.lookupClientSf(selectedClient.Id).then(function (results) {
                    $ctrl.clientTemp.SfAccountData = results;
                    $ctrl.transaction.Email = $ctrl.clientTemp.SfAccountData.PersonEmail;
                    $ctrl.ui.saving = false;
                });
            }
        }

        function getProsperaAdvisorClients() {
            prosperaSalesForceApi.lookupAdvisorClientsSf().then(function (results) {
                console.log(results)
                $ctrl.prosperaClients = results;
            });
        }

        function setQuestions(transactionId) {
            return questionApi.getQuestionCategories($ctrl.transactionGroup.Id).then(function (categories) {
                var promises = [];
                ng.forEach(categories, function (category) {
                    promises.push(transactionQuestionApi.createTransactionQuestionCategory({
                        TransactionId: transactionId,
                        Name: category.Name,
                        Order: category.Order
                    }).then(function (response) {
                        var innerPromises = [];

                        ng.forEach(category.QuestionList,
                            function (question) {
                                innerPromises.push(transactionQuestionApi.createTransactionQuestion({
                                    CategoryId: response.Id,
                                    Type: question.Type,
                                    Required: question.Required,
                                    PossibleAnswers: question.PossibleAnswers,
                                    QuestionText: question.QuestionText,
                                    Order: question.Order,
                                    IsActive: true,
                                    Answer: null,
                                    StockQuestionId: question.StockQuestionId
                                }));
                            });
                        return $q.all(innerPromises);
                    }));
                });
            });
        }

        function setProducts(transactionId) {
            return transactionGroupProductApi.getPublishedProducts($ctrl.transactionGroup.Id).then(function (products) {
                var promises = [];

                ng.forEach(products,
                    function (product) {
                        promises.push(transactionProductApi.createTransactionProduct({
                            ProductId: product.ProductId,
                            TransactionId: transactionId,
                            Name: product.Product.Name,
                            Cusip: product.Product.Cusip,
                            FireLightProductcode: product.Product.FireLightProductCode,
                            RightBridgeProductCode: product.Product.RightBridgeProductCode,
                            RetireUpProductCode: product.Product.RetireUpProductCode,
                            LineOfBusinessCategoryId: product.Product.LineOfBusinessCategory.Id,
                            CarrierId: product.Product.Carrier.Id,
                            CarrierName: product.Product.Carrier.Business.Name,
                            LineOfBusinessCategoryName: product.Product.LineOfBusinessCategory.Name,
                            ExcludeFromReviewQueue: product.ExcludeFromReviewQueue
                        }));
                    });
            });
        }

        function save($event) {
            if ($ctrl.transactionGroup.Name === "Prospera" && ng.isUndefined($ctrl.clientTemp.SfAccountData)) {

                var clientError = $mdDialog.alert({
                    title: "Please select an existing Salesforce client.",
                    ariaLabel: "Error alert",
                    ok: "Ok",
                    skipHide: true
                });
                return $mdDialog.show(clientError);
            }

            document.activeElement.blur();
            $ctrl.ui.saving = true;
            var promise = null;
            if (!$ctrl.existingClient) {
                promise = clientApi.add($ctrl.client)
                    .then(function (dbClient) {
                        $ctrl.client = dbClient;
                        return $ctrl.transaction.ClientId = $ctrl.client.Id;
                    });
            }
            $q.when(promise)
                .then(function () {
                    $ctrl.transaction.ClientId = $ctrl.transaction.ClientId || $ctrl.existingClient.Id;
                    $ctrl.transaction.PrimaryAgentId = $ctrl.primaryAgent.Id;
                    $ctrl.transaction.Agents = _.map($ctrl.secondaryAgents, "Id");
                    transactionApi.add($ctrl.transaction)
                        .then(function (dbTransaction) {

                            var relationship = {
                                TransactionId: dbTransaction.Id,
                                RelatedClientId: $ctrl.transaction.ClientId || $ctrl.existingClient.Id,
                                Type: "Client"
                            };

                            return transactionRelationshipApi.add(dbTransaction.Id, relationship)
                                .then(function (rel) {

                                    return transactionRelationshipApi.get(dbTransaction, rel.Id).then(function (response) {

                                        relationship = response;
                                        relationship.EmailAddress = { Value: $ctrl.transaction.Email }

                                        if ($ctrl.transactionGroup.Name === "Prospera") {

                                            relationship.PhysicalAddress =
                                            {
                                                Line1: $ctrl.clientTemp.SfAccountData.PersonMailingStreet,
                                                //Line2: "",
                                                City: $ctrl.clientTemp.SfAccountData.PersonMailingCity,
                                                State: $ctrl.clientTemp.SfAccountData.PersonMailingState,
                                                PostalCode: $ctrl.clientTemp.SfAccountData.PersonMailingPostalCode
                                            };

                                            if ($ctrl.clientTemp.SfAccountData.Phone != null)
                                                relationship.PhoneNumber = { Value: $ctrl.clientTemp.SfAccountData.Phone.replace(/\D/g, "") }
                                            relationship.Person.Dob = new Date($ctrl.clientTemp.SfAccountData.payout__Client_Birthdate__c);
                                            var dob = moment(relationship.Person.Dob);
                                            relationship.Person.Age = moment().diff(dob, "years");

                                            if ($ctrl.clientTemp.SfAccountData.payout__SSN__c.length === 9) {
                                                relationship.Person.Ssn = $ctrl.clientTemp.SfAccountData.payout__Soc_Sec_Number__c.replace(/[^0-9]/g, "");
                                                personApi.updateSsn(relationship.Person.Id, { Ssn: relationship.Person.Ssn });
                                            }

                                            personApi.update(relationship.Person).then(function () {

                                                var externalSfCleint = {
                                                    TransactionId: dbTransaction.Id,
                                                    ClientId: $ctrl.transaction.ClientId,
                                                    SfAccountId: $ctrl.clientTemp.SfAccountData.Id,
                                                    ExternalSfEntity: "Prospera"
                                                };

                                                return salesForceApi.createExternalSfClientRecord(externalSfCleint).then(function (results) {
                                                    return;
                                                });
                                            });
                                        };

                                        return transactionRelationshipApi.update(dbTransaction.Id, relationship.Id, relationship).then(function () {
                                            $ctrl.setQuestions(dbTransaction.Id).then(function () {
                                                $ctrl.setProducts(dbTransaction.Id).then(function () {
                                                    $ctrl.ui.saving = false;
                                                    $state.go("Transaction.Disclose", { transactionId: dbTransaction.Id }, { reload: true });
                                                });

                                            });
                                        });
                                    });
                                });
                        });
                }, function (error) {
                    $ctrl.ui.saving = false;
                    $mdDialog.show(errorAlert);
                });
        }
    }
})(window.app, window.angular);